import { useEffect } from 'react';

/**
 * Sets document.body overflow to hidden while locked so wheel/touch scrolling
 * does not move the page behind fixed fullscreen overlays.
 */
export function useBodyScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [locked]);
}
